import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";

export function WishlistHeart({ productId, overlay = false, size = 16, className = "" }) {
  const { has, toggle } = useWishlist();
  const active = has(productId);
  const onClick = (e) => { e.preventDefault(); e.stopPropagation(); toggle(productId); };
  const base = overlay
    ? "absolute top-2 right-2 z-10 bg-black/60 backdrop-blur rounded-full p-2 transition-colors hover:bg-black/85"
    : "inline-flex items-center justify-center rounded-full border border-white/15 bg-white/5 p-2.5 transition-colors hover:border-[#df1721]/70";
  return (
    <button type="button" onClick={onClick} aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      title={active ? "Remove from wishlist" : "Add to wishlist"}
      data-testid={`wishlist-heart-${productId}`} className={`${base} ${className}`}>
      <Heart size={size} className={`transition-transform ${active ? "text-[#df1721] fill-[#df1721] scale-110" : "text-white"}`} />
    </button>
  );
}
